import api from "../../../services/api";

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import * as globalComponents from "../../../components";

import "../styles.css";

export default function BidScene() {
  const { accessType, bidID } = useParams();

  const dir = [
    {
      title: "Licitações",
      url: `/${accessType}/licitacoes`,
    },
  ];

  const [data, setData] = useState({
    Titulo: null,
    Subtitulo: null,
    Chamada: null,
    Data_Publicacao: null,
    Materia: null,
  });

  useEffect(() => {
    window.scroll(0, 0);
    async function fetchData() {
      await api
        .get(`/conteudo/${bidID.split("_").pop()}`)
        .then((response) => {
          setData(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    fetchData();
  }, [bidID]);

  return (
    <>
      <globalComponents.Header />

      <globalComponents.Breadcrumbs title={data.Titulo} dir={dir} />

      <div className="container">
        <div className="content-wrapper">
          <globalComponents.PageTitle
            title={data.Titulo}
            subtitle={data.Subtitulo}
            span={data.Data_Publicacao}
          />

          <div
            className="content-text"
            dangerouslySetInnerHTML={{ __html: data.Materia }}
          ></div>
        </div>
      </div>

      <globalComponents.Footer />
    </>
  );
}
